import { render } from "./endpoints.vue?vue&type=template&id=58058644"
import script from "./endpoints.vue?vue&type=script&lang=js"
export * from "./endpoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__